import { SceneRoot } from './scene/SceneRoot'
import { PermissionGate } from './tracking/PermissionGate'
import { CameraBadge } from './ui/CameraBadge'
import { CalibrateButton } from './ui/CalibrateButton'
import { DebugHUD } from './ui/DebugHUD'
import { LoadingSplash } from './ui/LoadingSplash'
import { SkipButton } from './ui/SkipButton'
import { SiteFrame } from './ui/SiteFrame'
import { WelcomeTitle } from './ui/WelcomeTitle'
import { Fireworks } from './scene/Fireworks'
import { useAppStore } from './store/appStore'

export default function App() {
  const view = useAppStore((s) => s.currentView)
  const phase = useAppStore((s) => s.phase)
  const isIntroUIVisible = view === 'intro' && phase === 'idle'

  return (
    <div className="app-root">
      <LoadingSplash />
      {view === 'intro' && <SceneRoot />}
      <div className={`ui-layer${isIntroUIVisible ? '' : ' ui-layer--hidden'}`}>
        {view === 'intro' && (
          <>
            <WelcomeTitle />
            <PermissionGate />
            <CameraBadge />
            <CalibrateButton />
            <SkipButton />
            {import.meta.env.DEV && <DebugHUD />}
          </>
        )}
      </div>
      <SiteFrame />
      <Fireworks />
    </div>
  )
}
